import { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames/bind'
import { DatePicker } from 'antd'
import moment from 'moment'
import { format } from 'date-fns'

// Libs

// Components
import Icon from '@/assets/icons'

// Constants

// Styles
import styles from './style.module.scss'

// Variables
const cx = classnames.bind(styles)

// PropTypes
const propTypes = {
  className: PropTypes.string,
  value: PropTypes.string,
  defaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  defaultPickerValue: PropTypes.string,
  placeholder: PropTypes.string,
  showToday: PropTypes.bool,
  bordered: PropTypes.bool,
  inputReadOnly: PropTypes.bool,
  allowClear: PropTypes.bool,
  fieldItemRef: PropTypes.object,
  isHideAntdInputValue: PropTypes.bool,
}

const defaultProps = {
  value: '',
  defaultValue: '',
  placeholder: '',
  showToday: false,
  bordered: false,
  allowClear: false,
  inputReadOnly: true,
  isHideAntdInputValue: true,
}

function DatepickerComponent(props) {
  const {
    className,
    showToday,
    bordered,
    value,
    defaultValue,
    defaultPickerValue,
    placeholder,
    inputReadOnly,
    fieldItemRef,
    isHideAntdInputValue,
    ...restProps
  } = props

  const [isOpen, setIsOpen] = useState(false)

  const currentDate = value ? format(new Date(value), 'yyyy/MM/dd') : ''

  useEffect(() => {
    // 因為目前 FieldItem 的設計，只好把 setIsOpen 做在 fieldItem 的 onClick
    // 理想上 setIsOpen 只做在 Datepicker

    const fieldItem = fieldItemRef?.current

    const handleFieldItemClick = () => {
      setIsOpen(true)
    }

    if (fieldItem) {
      fieldItem.addEventListener('click', handleFieldItemClick)
    }

    return () => {
      if (fieldItem) {
        fieldItem.removeEventListener('click', handleFieldItemClick)
      }
    }
  }, [fieldItemRef])

  return (
    <div>
      <DatePicker
        {...restProps}
        className={cx('datepicker', className, { isHideInput: isHideAntdInputValue })}
        value={value ? moment(value) : ''}
        defaultValue={defaultValue ? moment(defaultValue) : ''}
        defaultPickerValue={defaultPickerValue ? moment(defaultPickerValue) : ''}
        placeholder={defaultValue ? placeholder : ''}
        showToday={showToday}
        bordered={bordered}
        inputReadOnly={inputReadOnly}
        open={isOpen}
        suffixIcon={
          <div className={cx('datepicker-dropdown')}>
            <Icon.Dropdown className={cx('datepicker-dropdown-icon')} data-is-open={isOpen} />
          </div>
        }
        onOpenChange={(open) => setIsOpen(open)}
        getPopupContainer={() => document.getElementById('app')}
      />
      <p className={cx('datepicker-value')}>{currentDate}</p>
    </div>
  )
}

DatepickerComponent.propTypes = propTypes
DatepickerComponent.defaultProps = defaultProps

export default DatepickerComponent
